module.exports = __webpack_public_path__ + "img/PF.59037540.svg";